import { jsx as _jsx } from "react/jsx-runtime";
import { Layout } from '@/shared/modules/layout';
import { AppSidebar } from './AppSidebar';
const AccessLevelLayout = () => {
    return _jsx(Layout, { sidebar: _jsx(AppSidebar, {}) });
};
export { AccessLevelLayout };
